


























import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { Tracking } from '../../../api/v2/models/activity_data'

@Component({})
export default class UserTrackingChangeDialog extends Vue {
  @Prop({ required: true })
  tracking: Tracking

  @Prop()
  update: (tracking: Tracking, totalRecordedValue: number) => Promise<void>

  hours: number = 0
  minutes: number = 0

  dialog = false

  @Watch('tracking', { immediate: true })
  watchTracking() {
    if (this.tracking) {
      this.hours = this.tracking.timeValue.hours
      this.minutes = this.tracking.timeValue.minutes
    }
  }

  numberRules = [(v) => !!v || '値入力必要']

  async onUpdate() {
    if (this.update) {
      await this.update(this.tracking, this.hours * 60 * 60 + this.minutes * 60)
    }
    this.dialog = false
  }
}
